@if(entrepreneurProspectDetails(); as details) {
<div class="entrepreneur-prospect-overview-dialog-part d-flex flex-column h-100">
	<readonly-access [readonly]="dialogDataService.isReadonly()"></readonly-access>

	<div class="flex-grow-1 d-flex flex-column">

		<div class="d-flex gap-3 align-items-center mb-4">
			<h4 class="mb-0">
				Prospect: {{details.fullName}}
				<span class="ms-2 pointer" type="button" title="View Person"
					(click)="openPersonDialog(details.personId!)">
					<i class="fa-regular fa-user"></i>
				</span>
			</h4>
			<h6 class="mb-0">
				({{details.type}})
			</h6>
		</div>

		<div class="row flex-grow-1">
			<div class="col-lg-6">
				<div class="d-flex flex-column gap-3 bg-light rounded shadow-sm h-100">
					<h5 class="pt-2 ps-1 mb-0">
						<span class="badge bg-secondary-subtle text-black px-3 py-2">
							Entrepreneur Lead
						</span>
					</h5>

					<div class="flex-grow-1 d-flex flex-column justify-content-between p-3 pt-0">

						<div>
							<table class="pro-table pro-table-no-background pro-table-with-labels pro-table-without-border">
								<tbody>
									<tr>
										<td>Lead Created On</td>
										<td>{{details.accLead.formattedCreatedUTC}} ({{details.accLead.startTrimesterName}})</td>
									</tr>
									<tr>
										<td>Latest Activity</td>
										<td>{{details.accLead.formattedLastActivityUTC}}</td>
									</tr>
								</tbody>
							</table>

							<table class="pro-table pro-table-no-background pro-table-with-labels pro-table-without-border mt-3">
								<tbody>
									<tr>
										<td>Language</td>
										<td>{{details.accLead.language}}</td>
									</tr>
									<tr>
										<td>Location</td>
										<td>{{details.location}}</td>
									</tr>
								</tbody>
							</table>

							<ng-container *ngTemplateOutlet="businessDetails; context: { details: details.accLead }"></ng-container>

							<table class="pro-table pro-table-no-background pro-table-with-labels pro-table-without-border mt-3">
								<tbody>
									<tr>
										<td>Heard From</td>
										<td>{{details.accLead.questionnaireLearn}}</td>
									</tr>
								</tbody>
							</table>
						</div>

						<common-button-row [center]="true">
							@if(details.accLead.leadStatus === 'Open'){
							<button class="btn btn-standard" (click)="markAsClosed()" [disabled]="dialogDataService.isReadonly()">Close this Lead</button>
							} @else {
							<button class="btn btn-standard" (click)="markAsOpen()" [disabled]="dialogDataService.isReadonly()">Reopen this Lead</button>
							}
						</common-button-row>

					</div>
				</div>

			</div>

			<div class="col-lg-6">
				<div class="d-flex flex-column gap-3 bg-light rounded shadow-sm h-100">
					<h5 class="pt-2 ps-1 mb-0">
						<span class="badge bg-secondary-subtle text-black px-3 py-2">
							Application Status
						</span>
					</h5>

					<div class="flex-grow-1 d-flex flex-column justify-content-between p-3 pt-0">
						@if(details.accApplication; as accApp) {
						<div>
							<table class="pro-table pro-table-no-background pro-table-with-labels pro-table-without-border">
								<tbody>
									<tr>
										<td>Venture Name</td>
										<td>{{accApp.ventureName}}</td>
									</tr>
									<tr>
										<td>Language</td>
										<td>{{accApp.language}}</td>
									</tr>
									<tr>
										<td>Created On</td>
										<td>{{accApp.formattedCreatedUTC}}</td>
									</tr>
									<tr>
										<td>Submitted On</td>
										<td>{{accApp.formattedFirstSubmissionUTC ? accApp.formattedFirstSubmissionUTC : 'Not Submitted'}}</td>
									</tr>
								</tbody>
							</table>

							<table class="pro-table pro-table-no-background pro-table-with-labels pro-table-without-border mt-3">
								<tbody>
									<tr>
										<td>Status</td>
										<td>{{accApp.accAppStatus}}</td>
									</tr>
									@if(accApp.trimesterSwitchoverStatus) {
									<tr>
										<td>Status at Switchover</td>
										<td>{{accApp.trimesterSwitchoverStatus}}</td>
									</tr>
									}
								</tbody>
							</table>

							<ng-container *ngTemplateOutlet="businessDetails; context: { details: accApp }"></ng-container>

							<table class="pro-table pro-table-no-background pro-table-with-labels pro-table-without-border mt-3">
								<tbody>
									<tr>
										<td>Co-Participant</td>
										<td>
											@if(accApp.coParticipant) {
											{{accApp.coParticipant.fullName}} ({{accApp.coParticipant.hasAccepted ? 'Accepted' : 'Pending'}})
											} @else {
											None
											}
										</td>
									</tr>
								</tbody>
							</table>
						</div>

						<common-button-row [center]="true">
							<button class="btn btn-standard" (click)="openApplicationDetails()">View Application
								Details</button>
						</common-button-row>
						}

						@else {
						<div>
							{{details.firstName}} has not yet created an application for {{details.currentTrimesterName}}.
						</div>
						}
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
}

<ng-template #businessDetails let-details="details">
	<table class="pro-table pro-table-no-background pro-table-with-labels pro-table-without-border mt-3">
		<tbody>
			<tr>
				<td>Business Stage</td>
				<td>{{details.businessStage}}</td>
			</tr>
			<tr>
				<td>Business Type</td>
				<td>{{details.businessType}}</td>
			</tr>
			<tr>
				<td>Industry</td>
				<td>{{details.industryName}}</td>
			</tr>
			<tr>
				<td>Offerings</td>
				<td>{{details.offerings}}</td>
			</tr>
		</tbody>
	</table>
</ng-template>